export function getUserActivePermissions(userInfo) {
  return Object.entries(userInfo || {}).reduce((accumulator, [key, value]) => {
    return (key.startsWith('can_') || key.startsWith('is_')) && !!value
      ? [...accumulator, key]
      : accumulator;
  }, []);
}
